/**
 * @generated SignedSource<<778f993a91d6402948ce68dd4eaa59f6>>
 * @relayHash 94ab41008639f3ad84b4070342bb8269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9af7f18859ec6c677a0d801ece22c4fe6ab6b26ac0fc6730de10229e59340b8f

import type { ConcreteRequest } from 'relay-runtime';
export type agentSessionEventsSubscription$variables = {
  accountId: string;
  cloudId: string;
  workspaceAri: string;
};
export type agentSessionEventsSubscription$data = {
  readonly convoai_onInboxSessionChanged: {
    readonly session: {
      readonly __typename: "AgentSession";
      readonly agentAccountId: string | null;
      readonly conversationChannel: {
        readonly createdAt: AGG$Long | null;
        readonly id: string | null;
        readonly interactionChannel: string | null;
        readonly interactionChannelAri: string | null;
        readonly isPinned: boolean | null;
        readonly isPlanning: boolean | null;
        readonly lastAgentMessageId: string | null;
        readonly lastAgentMessageStatus: string | null;
        readonly lastMessage: string | null;
        readonly lastMessageTimestamp: AGG$Long | null;
        readonly lastMessageType: ReadonlyArray<string | null> | null;
        readonly name: string | null;
        readonly pinnedAt: AGG$Long | null;
        readonly readStatus: boolean | null;
        readonly status: string | null;
      } | null;
      readonly convoAiAgentId: string | null;
      readonly expireTime: AGG$DateTime | null;
      readonly hasUnseenActivity: boolean | null;
      readonly id: string | null;
      readonly invocationType: string | null;
      readonly isRovo: boolean | null;
      readonly lastStateChangeAt: AGG$Long | null;
      readonly state: string | null;
      readonly stateReason: string | null;
    } | null;
    readonly sessionAri: string;
    readonly sessionId: string;
  } | null;
};
export type agentSessionEventsSubscription = {
  response: agentSessionEventsSubscription$data;
  variables: agentSessionEventsSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceAri"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "ConvoAiInboxSessionChanged",
    "kind": "LinkedField",
    "name": "convoai_onInboxSessionChanged",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "sessionId"
      },
      {
        "kind": "ScalarField",
        "name": "sessionAri"
      },
      {
        "concreteType": "AgentSession",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "hasUnseenActivity"
          },
          {
            "kind": "ScalarField",
            "name": "invocationType"
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "state"
          },
          {
            "kind": "ScalarField",
            "name": "stateReason"
          },
          {
            "kind": "ScalarField",
            "name": "expireTime"
          },
          {
            "kind": "ScalarField",
            "name": "lastStateChangeAt"
          },
          {
            "kind": "ScalarField",
            "name": "isRovo"
          },
          {
            "kind": "ScalarField",
            "name": "agentAccountId"
          },
          {
            "kind": "ScalarField",
            "name": "convoAiAgentId"
          },
          {
            "alias": "conversationChannel",
            "concreteType": "AgentConversationChannel",
            "kind": "LinkedField",
            "name": "nativeConversationChannel",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "createdAt"
              },
              {
                "kind": "ScalarField",
                "name": "interactionChannel"
              },
              {
                "kind": "ScalarField",
                "name": "interactionChannelAri"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "lastMessage"
              },
              {
                "kind": "ScalarField",
                "name": "lastMessageTimestamp"
              },
              {
                "kind": "ScalarField",
                "name": "lastMessageType"
              },
              {
                "kind": "ScalarField",
                "name": "lastAgentMessageId"
              },
              {
                "kind": "ScalarField",
                "name": "lastAgentMessageStatus"
              },
              {
                "kind": "ScalarField",
                "name": "readStatus"
              },
              {
                "kind": "ScalarField",
                "name": "isPlanning"
              },
              {
                "kind": "ScalarField",
                "name": "isPinned"
              },
              {
                "kind": "ScalarField",
                "name": "pinnedAt"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "agentSessionEventsSubscription",
    "selections": (v2/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentSessionEventsSubscription",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "9af7f18859ec6c677a0d801ece22c4fe6ab6b26ac0fc6730de10229e59340b8f",
    "metadata": {},
    "name": "agentSessionEventsSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "0a85066b3c819a1c08606ccd13bc9662";

export default node;
